import { StoreHistory } from '../../../models/manager-content-vehicle-history-drawer.model';
import { DropdownOption } from '../models/content-vehicle-history-drawer.model';

export function adaptStoreHistoryToDropdownOption(
  storeHistory: StoreHistory
): DropdownOption {
  return {
    name: storeHistory.unit.unitName || '',
    code: storeHistory.unit.GNSSIMEI,
  };
}

export function adapStoreHistoriesToDropdownOptions(
  storeHistories: StoreHistory[]
): DropdownOption[] {
  return storeHistories.map(adaptStoreHistoryToDropdownOption);
}
